<template>
    <v-container>
        <h2>Password Station</h2>
        <v-row>
            <v-text-field v-model="emailVerification"></v-text-field>
        </v-row>
        <v-row v-if="emailVerification">
            <v-text-field v-model="password"></v-text-field>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        attempts: 0,
        emailVerification: null,
        password: null,
    }),
    methods: {
        verifyEmail() {},
    },
}
</script>
